import React, { useState } from 'react'
import { baixarMidiaWhatsApp, extrairMidiaMensagem } from '../services/whatsappCrmApi'

const cacheBlobs = new Map()

function garantirCache(mensagemId, blob, mimeType) {
  const atual = cacheBlobs.get(mensagemId)
  if (atual) return atual
  const url = URL.createObjectURL(blob)
  cacheBlobs.set(mensagemId, { url, mimeType, blob })
  return cacheBlobs.get(mensagemId)
}

const WhatsAppMediaBubble = ({ mensagem, userId, kind }) => {
  const midia = extrairMidiaMensagem(mensagem?.payload, mensagem?.message_id)
  const [src, setSrc] = useState(() => cacheBlobs.get(mensagem.id)?.url || '')
  const [mimeType, setMimeType] = useState(() => cacheBlobs.get(mensagem.id)?.mimeType || '')
  const [carregando, setCarregando] = useState(false)
  const [erro, setErro] = useState(null)

  const carregar = async () => {
    if (src || carregando || !userId) return null
    setCarregando(true)
    setErro(null)
    const res = await baixarMidiaWhatsApp({ usuarioId: userId, mensagemId: mensagem.id })
    setCarregando(false)
    if (!res.success) {
      setErro(res.error)
      return null
    }
    const cached = garantirCache(mensagem.id, res.blob, res.mimeType)
    setSrc(cached.url)
    setMimeType(cached.mimeType)
    return cached
  }

  const baixarArquivo = async () => {
    const cached = src
      ? { url: src, mimeType, blob: cacheBlobs.get(mensagem.id)?.blob }
      : await carregar()
    if (!cached?.url) return
    const a = document.createElement('a')
    a.href = cached.url
    a.download = midia?.filename || (kind === 'image' ? 'imagem.jpg' : 'arquivo')
    a.click()
  }

  const rotulo = kind === 'image'
    ? 'Ver foto'
    : kind === 'video'
      ? 'Ver vídeo'
      : (midia?.filename ? `Baixar ${midia.filename}` : 'Baixar arquivo')

  return (
    <div className="wa-media">
      {kind === 'image' && src && (
        <img className="wa-media-img" src={src} alt={midia?.caption || 'Foto'} />
      )}
      {kind === 'video' && src && (
        <video className="wa-media-video" src={src} controls preload="metadata" />
      )}
      {kind === 'document' && (
        <div className="wa-media-doc">
          <i className="bi bi-file-earmark-text" />
          <span>{midia?.filename || mensagem.body || 'Documento'}</span>
        </div>
      )}
      {midia?.caption && kind !== 'document' && (
        <div className="wa-media-caption">{midia.caption}</div>
      )}
      {!src && kind !== 'document' && (
        <button
          type="button"
          className="wa-audio-play"
          onClick={carregar}
          disabled={carregando || !userId}
        >
          <i className={`bi ${carregando ? 'bi-arrow-repeat' : (kind === 'video' ? 'bi-play-fill' : 'bi-image')}`} />
          <span>{carregando ? 'Carregando...' : rotulo}</span>
        </button>
      )}
      {kind === 'document' && (
        <button
          type="button"
          className="wa-audio-play"
          onClick={baixarArquivo}
          disabled={carregando || !userId}
        >
          <i className={`bi ${carregando ? 'bi-arrow-repeat' : 'bi-download'}`} />
          <span>{carregando ? 'Carregando...' : 'Baixar'}</span>
        </button>
      )}
      {erro && <span className="wa-audio-erro">{erro}</span>}
    </div>
  )
}

export default WhatsAppMediaBubble
